// Documentos da empresa — a casa do acervo (2026-08-19).
//
// Até aqui o acervo era uma aba de terceiro nível dentro de Comercial ›
// Licitações, porque nasceu para habilitação em pregão. Só que contrato social,
// CRLV da frota, apólice de seguro, contrato de locação, PGR/PCMSO e documento
// de sócio não são assunto de licitação — são da empresa. Quem cadastra e
// atualiza é o Administrativo; o Comercial consulta e baixa (a mesma tabela,
// em modo leitura, na aba de Licitações).
//
// Duas abas com papéis opostos e complementares: o Acervo responde "o que eu
// tenho"; o Checklist, "o que está faltando". Clicar na pista de uma linha
// vermelha do checklist traz para o Acervo já filtrado — é o caminho de quem
// vai procurar o documento que provavelmente já está lá, só mal classificado.
//
// Declaração específica de edital continua sendo criada na tela da licitação:
// o backend separa os dois donos pelo escopo do documento, não pela tela.
import { useState } from 'react';
import { App as AntApp, Typography, Tabs } from 'antd';
import { PainelDocumentosEmpresa } from './administrativo-documentos/PainelDocumentosEmpresa';
import { ChecklistEsperados } from './administrativo-documentos/ChecklistEsperados';
import { PainelCofre } from './administrativo-documentos/PainelCofre';

const { Title, Text } = Typography;

export default function AdministrativoDocumentos() {
  const [aba, setAba] = useState('acervo');
  const [filtroInicial, setFiltroInicial] = useState<{ categoria_codigo: string } | null>(null);
  // As duas abas olham o MESMO dado por ângulos diferentes: anexar pelo
  // Checklist cria documento no Acervo, e classificar um documento no Acervo
  // fecha um item do Checklist. O antd mantém a aba inativa montada, então sem
  // isto a outra fica velha — foi assim que classificar o Cartão CNPJ pareceu
  // não ter efeito (20/08/2026).
  //
  // ⚠️ Duas chaves, não uma: cada lado invalida O OUTRO. Com chave única,
  //    salvar no Acervo remontaria o próprio Acervo e o usuário perderia o
  //    filtro e a posição da lista bem no meio do trabalho.
  const [versaoAcervo, setVersaoAcervo] = useState(0);
  const [versaoChecklist, setVersaoChecklist] = useState(0);

  return (
    <AntApp>
      <div style={{ padding: 16 }}>
        <Title level={4} style={{ marginBottom: 2 }}>🗂️ Documentos da empresa</Title>
        <Text type="secondary" style={{ fontSize: 12, display: 'block', marginBottom: 16 }}>
          Acervo institucional: contrato social, certidões, alvará, CRLV e apólices da frota,
          contratos de locação, PGR/PCMSO, certificados e registros. O Comercial consulta este
          mesmo acervo na aba de Licitações.
        </Text>

        <Tabs
          size="small"
          activeKey={aba}
          onChange={setAba}
          items={[
            {
              key: 'acervo',
              label: 'Acervo',
              children: (
                <PainelDocumentosEmpresa
                  key={`acervo-${versaoAcervo}`}
                  modo="gestao"
                  filtroInicial={filtroInicial}
                  onAcervoMudou={() => setVersaoChecklist((v) => v + 1)}
                />
              ),
            },
            {
              key: 'checklist',
              label: 'Checklist',
              children: (
                <ChecklistEsperados
                  key={`checklist-${versaoChecklist}`}
                  onIrParaAcervo={(f) => { setFiltroInicial(f); setAba('acervo'); }}
                  onAcervoMudou={() => setVersaoAcervo((v) => v + 1)}
                />
              ),
            },
            {
              // O cofre mora aqui, e não num menu próprio, porque o certificado
              // digital JÁ é um documento do acervo — o que faltava era onde
              // guardar a senha dele. Separar em duas telas obrigaria a
              // atravessar o sistema para usar uma coisa só.
              //
              // Sem `key` de versão: o cofre não compartilha dado com as outras
              // abas, e remontá-lo à toa descartaria o cronômetro do valor
              // revelado no meio de um "Ctrl+C".
              key: 'cofre',
              label: '🔐 Cofre',
              children: <PainelCofre />,
            },
          ]}
        />
      </div>
    </AntApp>
  );
}
